import { Kiosk, SoftExpressData } from "domains/kiosk/aggregates/Kiosk";
import { IPinpadService } from "modules/payment/application/interfaces/IPinpadService";
import { Payment } from "modules/payment/domain/models/IPayment";
import { TransactionType } from "modules/payment/domain/models/TransactionType";
import { openMsitefActions, SitefMetadata, transaction, TransactionResponse } from "modules/reactNativeBridge/ReactNativeBridge";

export function getSoftExpressPagSeguroSubAcquirerData(data: SoftExpressData): string {
  // Validação mínima de campos obrigatórios
  if (
    !data.facilitatorMerchantId?.trim() ||
    !data.merchantId?.trim() ||
    !data.cnpjCpf?.trim()
  ) {
    return '';
  }

  const nomeFantasia = `00${(data.name?.length ?? 0).toString().padStart(2, '0')}${data.name ?? ''}`;
  const endereco = `01${(data.address?.length ?? 0).toString().padStart(2, '0')}${data.address ?? ''}`;
  const cidade = `02${(data.city?.length ?? 0).toString().padStart(2, '0')}${data.city ?? ''}`;
  const uf = `03${(data.uf?.length ?? 0).toString().padStart(2, '0')}${data.uf ?? ''}`;
  const pais = `04${(data.country?.length ?? 0).toString().padStart(2, '0')}${data.country ?? ''}`;
  const cep = `05${(data.zipCode?.length ?? 0).toString().padStart(2, '0')}${data.zipCode ?? ''}`;
  const mcc = `06${(data.mcc?.length ?? 0).toString().padStart(2, '0')}${data.mcc ?? ''}`;
  const cnpjCpf = `07${(data.cnpjCpf?.length ?? 0).toString().padStart(2, '0')}${data.cnpjCpf ?? ''}`;
  const telefone = `08${(data.telephone?.length ?? 0).toString().padStart(2, '0')}${data.telephone ?? ''}`;
  const codigoEstabelecimentoId = `09${(data.merchantId?.length ?? 0).toString().padStart(2, '0')}${data.merchantId ?? ''}`;
  const razaoSocialCompleto = `11${(data.fullName?.length ?? 0).toString().padStart(2, '0')}${data.fullName ?? ''}`;
  const tipoPessoa = `12${(data.docType?.length ?? 0).toString().padStart(2, '0')}${data.docType ?? ''}`;
  const facilitatorMerchantId = `13${(data.facilitatorMerchantId?.length ?? 0).toString().padStart(2, '0')}${data.facilitatorMerchantId ?? ''}`;

  return `[DadosSubAdquirencia=${nomeFantasia}${endereco}${cidade}${uf}${pais}${cep}${mcc}${cnpjCpf}${telefone}${codigoEstabelecimentoId}${razaoSocialCompleto}${tipoPessoa}${facilitatorMerchantId}]`;
}

export const ReactNativePaymentRepository = (): IPinpadService => {
  const payAsync = async (
    amount: number,
    transactionType: TransactionType,
    kiosk?: Kiosk,
  ): Promise<Payment> => {
    if (!kiosk) {
      throw new Error("Kiosk não informado");
    }
    console.log("kiosk: ", kiosk);
    console.log("iniciando pagamento: ", amount);

    let cnpj_automacao = "28302604000101";

    //if (kiosk?.localId.toLowerCase() === "c7a93984-8407-7d73-268f-d54a21c0bb2f") { // Colégio Caetano - Sete Lagoas / MG
    //  cnpj_automacao = "00641418000188";
    //};

    const DEFAULT_CONFIG: SitefMetadata = {
      // empresaSitef: '00000000',
      // CNPJ_CPF: '47504905000162',
      // enderecoSitef: "192.168.0.68",
      // comExterna: "0",
      // tokenRegistroTls: "1234-5678-9012-3456",
      //prod
      empresaSitef: kiosk?.softExpressStoreCode ?? kiosk?.softExpressStoreCodeMeepSub ?? "",
      //tokenRegistroTls: "3328-9181-5198-9057", // "0269-2825-3325-9708", // "8226-9036-1068-5474", // kiosk.transireToken ?? "",
      tokenRegistroTls: kiosk?.softExpressToken ?? "", //?? "4816-4536-1060-5453",// ?? "5169-7583-3769-5927",// "1158-0483-1099-9343", //"0431-5207-6255-5749",
      enderecoSitef: "tls-prod.fiservapp.com:443",
      CNPJ_CPF: kiosk?.softExpressCnpj ?? kiosk?.softExpressCnpjMeepSub ?? "",
      //cnpj_automacao: "28302604000101", // kiosk?.softExpressCnpjMeepSub ,
      cnpj_automacao: cnpj_automacao, // kiosk?.softExpressCnpjMeepSub ,
      comExterna: "4",
      dadosSubAdqui: kiosk?.softExpressIsPagSeguroSubAcquirer ? getSoftExpressPagSeguroSubAcquirerData(kiosk?.softExpressPagSeguroSubAcquirerData ?? {}) : undefined,
      terminalSitef: kiosk?.kioskName ?? "",
    };
    console.log("kiosk?.softExpressIsPagSeguroSubAcquirer: ", kiosk?.softExpressIsPagSeguroSubAcquirer);
    console.log("kiosk?.softExpressPagSeguroSubAcquirerData: ", kiosk?.softExpressPagSeguroSubAcquirerData);
    console.log("kiosk?.softExpressToken: ", kiosk?.softExpressToken);
    console.log("kiosk?.softExpressCnpj: ", kiosk?.softExpressCnpj);
    console.log("kiosk?.softExpressCnpjMeepSub: ", kiosk?.softExpressCnpjMeepSub);
    console.log("kiosk?.softExpressStoreCode: ", kiosk?.softExpressStoreCode);
    console.log("kiosk?.softExpressStoreCodeMeepSub: ", kiosk?.softExpressStoreCodeMeepSub);
    console.log("kiosk?.kioskName: ", kiosk?.kioskName);


    console.log("DEFAULT_CONFIG: ", DEFAULT_CONFIG);

    console.log("iniciando transação: ", amount);
    const transactionResult = await transaction({
      amount: amount * 100,
      typeTransaction: transactionType,
      token: DEFAULT_CONFIG.tokenRegistroTls,
      aquirer: 'msitef',
      metadata: DEFAULT_CONFIG,
    });



    console.log("transactionResult: ", transactionResult);

    let bandeiraCartao = transactionResult.FinancialTransactionModel.BandeiraCartao;
    /*
          20002 = 1
          20001 = 2
          20032/ 31 = 3
    */
    if (bandeiraCartao === 20002) {
      bandeiraCartao = 1;
    } else if (bandeiraCartao === 20001) {
      bandeiraCartao = 2;
    } else if (bandeiraCartao === 20032 || bandeiraCartao === 31) {
      bandeiraCartao = 3;
    }
    const transactionResultAjuste: Payment = {
      ...transactionResult,
      FinancialTransactionModel: {
        ...transactionResult.FinancialTransactionModel,
        BandeiraCartao: bandeiraCartao,
      },
    }

    return transactionResultAjuste;
  };

  const cancelPaymentAsync = async (value: number, typePayment: TransactionType, couponNumber: string, paymentDate: string) => {
    throw new Error("Método não implementado");
  }




  const openConfig = async (config?: SitefMetadata): Promise<void> => {
    if (!config) {
      throw new Error("Configuração não informada");
    }
    await openMsitefActions({ config: config });
  }

  return { payAsync, cancelPaymentAsync, openConfig };

}
